import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Item1, Item2, Item3 } from './item.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  apiUrl: string = environment.apiBaseURL + '/View';

  constructor(private http: HttpClient) { }

  getTotalByPaisResidencia(): Observable<Item1[]> {
    return this.http.get<Item1[]>(this.apiUrl + '/TotalPorPaisResidencia');
  }

  getBytTipoRecolha(): Observable<Item2> {
    return this.http.get<Item2>(this.apiUrl + '/TotalPorTipoRecolha');
  }

  getByCountryCode(): Observable<Item1[]> {
    return this.http.get<Item1[]>(this.apiUrl + '/TotalPorPaisNoTerreno');
  }
}
